import { render } from "./icon-sleep-quality.svg?vue&type=template&id=b6fae8cc"
const script = {}

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__